const TOGGLE_USER_PANEL = 'TOGGLE_USER_PANEL';
const TOGGLE_LOGIN = 'TOGGLE_LOGIN';
const SAVE_USER_SETTINGS = 'SAVE_USER_SETTINGS';

export {
    TOGGLE_USER_PANEL,
    TOGGLE_LOGIN,
    SAVE_USER_SETTINGS
}